// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '4728a7c5-902e-41ce-940b-45aa3b755453',
      type: 'Container',
      name: 'coinOffer',
      className: '',
      x: -185,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '6d510f46-8fd5-4a3d-b06b-674167e15c88',
      type: 'Container',
      name: 'upsellOffer',
      className: '',
      x: 185,
      y: -9,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0ba0d3c8-f758-4644-838c-a10546e1f6b6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Left_Offer_Background',
      parent: '4728a7c5-902e-41ce-940b-45aa3b755453'
    },
    {
      id: '455aa308-2733-453b-b5d7-52047f124673',
      type: 'Sprite',
      name: '',
      className: '',
      x: -3,
      y: 202,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Left_Offer_Counter',
      parent: '4728a7c5-902e-41ce-940b-45aa3b755453'
    },
    {
      id: '395f8337-3b0c-48f9-a7a4-df17a35b65aa',
      type: 'Sprite',
      name: '',
      className: '',
      x: 2,
      y: 204,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Coins_Stack',
      parent: '4728a7c5-902e-41ce-940b-45aa3b755453'
    },
    {
      id: '735ad411-2289-4f4c-87ae-248b9c6baa78',
      type: 'Text',
      name: 'coinOfferAmount',
      className: '',
      x: -2,
      y: 231,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '500',
      localize: false,
      maxWidth: 141,
      maxHeight: 75,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '4728a7c5-902e-41ce-940b-45aa3b755453'
    },
    {
      id: 'ce9f5ef7-5e24-4f67-8e1b-c4fd546cde0e',
      type: 'Container',
      name: 'coinOfferBuyButton',
      className: '',
      x: 0,
      y: 291,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4728a7c5-902e-41ce-940b-45aa3b755453'
    },
    {
      id: '12d84a25-8a75-42b6-bad0-6291d2c760a9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Right_Offer_Background',
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: 'a3c46e93-cec4-439e-b1a7-cd5ac2752914',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: 184,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Right_Offer_Counter',
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: '28d8e4f9-c723-47e9-8156-6305da2cc61c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 207,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Coins_Stack',
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: '47b7bce9-f36a-4f97-bb1c-a8cc692e8fe5',
      type: 'Text',
      name: 'upsellCountdown',
      className: '',
      x: 25,
      y: -352,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1d 12h',
      localize: false,
      maxWidth: 114,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#6b017f',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: 'f6fee3ac-0944-4d5a-b875-699f5c337e41',
      type: 'Sprite',
      name: '',
      className: '',
      x: -64,
      y: -363,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: 'cf904c60-4101-4399-9e73-35a46fecde98',
      type: 'Text',
      name: 'upsellOfferCoinsAmount',
      className: '',
      x: -2,
      y: 231,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '500',
      localize: false,
      maxWidth: 141,
      maxHeight: 75,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: 'c9d2d4c9-eb62-4d26-8139-8d460d8a98a4',
      type: 'Container',
      name: 'upsellOfferBuyButton',
      className: '',
      x: 0,
      y: 299,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: 'e8ec32ba-20d8-44f1-b751-9371040305a7',
      type: 'Container',
      name: 'itemsContainer',
      className: '',
      x: 0,
      y: -263,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6d510f46-8fd5-4a3d-b06b-674167e15c88'
    },
    {
      id: '625e3ce2-8e5b-4f41-b249-51f9796c9160',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -121,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 241,
      height: 81,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Green',
      parent: 'ce9f5ef7-5e24-4f67-8e1b-c4fd546cde0e'
    },
    {
      id: '8b229fcc-4c28-4d5f-b6ed-ba01f7034cc9',
      type: 'Text',
      name: 'coinOfferPrice',
      className: '',
      x: 0,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '4.34PLN',
      localize: false,
      maxWidth: 213,
      maxHeight: 94,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#e7ffe6',
        stroke: '#01710f',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'ce9f5ef7-5e24-4f67-8e1b-c4fd546cde0e'
    },
    {
      id: 'cb15df84-26fe-427c-bdbf-ac7be26c24cf',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -121,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 241,
      height: 81,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Green',
      parent: 'c9d2d4c9-eb62-4d26-8139-8d460d8a98a4'
    },
    {
      id: '09812487-9d06-4bb1-a909-750fbee1772a',
      type: 'Text',
      name: 'upsellOfferPrice',
      className: '',
      x: 0,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '4.34PLN',
      localize: false,
      maxWidth: 213,
      maxHeight: 94,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#e7ffe6',
        stroke: '#01710f',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c9d2d4c9-eb62-4d26-8139-8d460d8a98a4'
    },
    {
      id: '3bbc8aa9-4cf4-43da-97e7-4824d73acf86',
      type: 'Container',
      name: '',
      className: 'upsellItemContainer',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e8ec32ba-20d8-44f1-b751-9371040305a7'
    },
    {
      id: '906818ab-d4d0-4a0c-8fbc-5ccf46045b19',
      type: 'Container',
      name: '',
      className: 'upsellItemContainer',
      x: 0,
      y: 90,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e8ec32ba-20d8-44f1-b751-9371040305a7'
    },
    {
      id: '05a77902-456f-4bcd-932d-9706aaa04a6c',
      type: 'Container',
      name: '',
      className: 'upsellItemContainer',
      x: 0,
      y: 180,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e8ec32ba-20d8-44f1-b751-9371040305a7'
    },
    {
      id: '99d5557a-9065-4b6c-9ad0-bbe08aa022bf',
      type: 'Container',
      name: '',
      className: 'upsellItemContainer',
      x: 0,
      y: 270,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e8ec32ba-20d8-44f1-b751-9371040305a7'
    },
    {
      id: '47e0fbc8-e974-49d6-8bba-86a99f2b1b21',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Right_Offer_Small_Counter',
      parent: '3bbc8aa9-4cf4-43da-97e7-4824d73acf86'
    },
    {
      id: '282b2275-dd9f-4d6a-bde4-e9467144251f',
      type: 'Sprite',
      name: '',
      className: 'upsellItemIcon',
      x: -40,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Infinite_Lives',
      parent: '3bbc8aa9-4cf4-43da-97e7-4824d73acf86',
      data: {
        maxSize: 70
      }
    },
    {
      id: '57d5076e-1ba2-4ac2-aa7d-f32da553c43d',
      type: 'Text',
      name: '',
      className: 'upsellItemAmount',
      x: 36,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3bbc8aa9-4cf4-43da-97e7-4824d73acf86'
    },
    {
      id: '13547693-9297-4292-aa2a-64fb9803cfc8',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Right_Offer_Small_Counter',
      parent: '906818ab-d4d0-4a0c-8fbc-5ccf46045b19'
    },
    {
      id: 'fc908129-8764-4344-bd7e-a98b6bb350f4',
      type: 'Sprite',
      name: '',
      className: 'upsellItemIcon',
      x: -40,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Infinite_Lives',
      parent: '906818ab-d4d0-4a0c-8fbc-5ccf46045b19',
      data: {
        maxSize: 70
      }
    },
    {
      id: 'cefbf3d8-41d0-4f0a-85f6-1c7eebc68dba',
      type: 'Text',
      name: '',
      className: 'upsellItemAmount',
      x: 36,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '906818ab-d4d0-4a0c-8fbc-5ccf46045b19'
    },
    {
      id: '39294507-8e64-40cd-9917-1141a6b3acb2',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Right_Offer_Small_Counter',
      parent: '05a77902-456f-4bcd-932d-9706aaa04a6c'
    },
    {
      id: 'd1b98f10-674a-46ca-9fe4-38a06a5c27a6',
      type: 'Sprite',
      name: '',
      className: 'upsellItemIcon',
      x: -40,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Infinite_Lives',
      parent: '05a77902-456f-4bcd-932d-9706aaa04a6c',
      data: {
        maxSize: 70
      }
    },
    {
      id: 'd3a2c56c-77e6-4cea-bde2-a70a6a19b078',
      type: 'Text',
      name: '',
      className: 'upsellItemAmount',
      x: 36,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '05a77902-456f-4bcd-932d-9706aaa04a6c'
    },
    {
      id: '84314beb-cf3e-4f87-b4e8-d08ee93882a2',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Right_Offer_Small_Counter',
      parent: '99d5557a-9065-4b6c-9ad0-bbe08aa022bf'
    },
    {
      id: '9bd30fad-1f23-4723-a018-939db7a81cd3',
      type: 'Sprite',
      name: '',
      className: 'upsellItemIcon',
      x: -40,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Infinite_Lives',
      parent: '99d5557a-9065-4b6c-9ad0-bbe08aa022bf',
      data: {
        maxSize: 70
      }
    },
    {
      id: '1559be15-0f7b-4e2d-92d4-a5b6a5c334b9',
      type: 'Text',
      name: '',
      className: 'upsellItemAmount',
      x: 36,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '99d5557a-9065-4b6c-9ad0-bbe08aa022bf'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class UpsellLayout {
  static raw = raw;
  root!: Container;
  coinOffer!: Container;
  upsellOffer!: Container;
  coinOfferAmount!: Text;
  coinOfferBuyButton!: Container;
  upsellCountdown!: Text;
  upsellOfferCoinsAmount!: Text;
  upsellOfferBuyButton!: Container;
  itemsContainer!: Container;
  coinOfferPrice!: Text;
  upsellOfferPrice!: Text;
  upsellItemContainer!: (Container)[];
  upsellItemIcon!: (Sprite & { data: typeof raw['list'][25]['data'] } | Sprite & { data: typeof raw['list'][28]['data'] } | Sprite & { data: typeof raw['list'][31]['data'] } | Sprite & { data: typeof raw['list'][34]['data'] })[];
  upsellItemAmount!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
